import { FC, useState } from "react";
import { Box } from "@chakra-ui/react";
import { useDnd, useDndAsset } from "domains/drag-and-drop";
import { AssetIframe } from "domains/single-asset/enhanced";
import { HtmlQuickActions } from "./htmlQuickActions";

export const HtmlAsset: FC<{ isEditable: boolean }> = ({ isEditable }) => {
  const { asset, path, isSelected, isDragging } = useDndAsset();
  const { onSelectItem } = useDnd();
  const { isDragInProgress } = useDnd();
  const [ isActive, setIsActive ] = useState(false);

  if (!asset) {
    return null;
  }

  return (
    <Box
      onClick={(e) => onSelectItem(e, path)}
      layerStyle={['with-asset-wrapper', 'with-text-asset', 'with-transition', (isEditable && !isDragInProgress) && 'with-selectable-asset']}
      borderColor={(isSelected || isDragging) ? 'brand.500' : 'transparent' }
      bgColor={isSelected ? 'brand.50' : 'transparent'}
      padding={(isSelected || isDragging) ? '12px' : '12px 0' }
      id="dnd-asset"
      onMouseEnter={isDragInProgress ? null : () => setIsActive(true)}
      onMouseLeave={isDragInProgress ? null : () => setIsActive(false)}
    >
      <AssetIframe data={asset.data.value} />
      { isEditable && (
        <Box position="absolute" top="0px" right="10px" translateY="-50%">
          <HtmlQuickActions isActive={isActive} />
        </Box>
      )}
    </Box>
  )
};
